<template>
  <v-container class="text-center justify-center align-center mt-6" fill-height>
    <v-row class="justify-center align-center">
      <v-col cols="12" sm="8" md="8">
        <v-card class="elevation-12">
          <v-window v-model="step">
            <v-window-item :value="1">
              <v-row>
                <v-col cols="12" md="7">
                  <v-row justify="center" class="mt-2">
                    <v-img
                      alt="Vuetify Logo"
                      class="justify-center shrink mt-8 mb-2"
                      contain
                      src="/img/login.png"
                      transition="scale-transition"
                      width="200"
                    />
                  </v-row>
                  <v-card-text class="mt-6">
                    <h1 class="text-center display-1 green--text">
                      ลงชื่อเข้าใช้งาน
                    </h1>
                    <h4 class="text-center mt-4">
                      Ensure your email for registration
                    </h4>
                    <v-form ref="formLogin" v-model="loginValid">
                      <v-text-field
                        label="Login"
                        name="login"
                        prepend-icon="mdi-email"
                        type="text"
                        color="green"
                        v-model="loginModel.email"
                      />

                      <v-text-field
                        id="password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        label="Password"
                        name="password"
                        prepend-icon="mdi-lock"
                        color="green"
                        @click:append="showPassword = !showPassword"
                        v-model="loginModel.password"
                      />
                    </v-form>
                    <h3 class="text-center mt-4">Forgot your password ?</h3>
                  </v-card-text>
                  <div class="text-center mt-1 pa-4">
                    <v-btn rounded color="green" dark @click="login"
                      >SIGN IN</v-btn
                    >
                  </div>
                </v-col>
                <v-col cols="12" md="5" class="green">
                  <v-card-text class="white--text mt-12">
                    <h1 class="text-center display-1">ยินดีต้อนรับ</h1>
                    <h5 class="text-center">
                      ป้อนข้อมูลรายละเอียดส่วนตัว เพื่อเป็นส่วนหนึ่งกับเรา
                    </h5>
                  </v-card-text>
                  <div class="text-center pa-4">
                    <v-btn rounded outlined dark @click="step++">SIGN UP</v-btn>
                  </div>
                  <v-row justify="center" class="mt-2">
                    <v-img
                      alt="Vuetify Logo"
                      class="text-center shrink mt-8 mb-2"
                      src="/img/agt.png"
                      transition="scale-transition"
                      width="120"
                    />
                  </v-row>
                  <v-row justify="center" class="mt-4">
                    <h5 class="text-center white--text">
                      ดาวน์โหลดแอปพลิเคชัน
                    </h5>
                  </v-row>
                </v-col>
              </v-row>
            </v-window-item>
            <!-- ลงทะเบียน -->
            <v-window-item :value="2">
              <v-row class="fill-height">
                <v-col cols="12" md="5" class="green">
                  <v-card-text class="white--text mt-12">
                    <h1 class="text-center display-1">Welcome Back!</h1>
                    <h5 class="text-center">
                      หากต้องการเชื่อมต่อกับเรา โปรดเข้าสู่ระบบด้วยข้อมูลของคุณ
                    </h5>
                  </v-card-text>
                  <div class="text-center">
                    <v-btn rounded outlined dark @click="step--">Sign in</v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="7">
                  <v-card-text class="mt-12">
                    <h1 class="text-center display-1 green--text">ลงทะเบียน</h1>
                    <h4 class="text-center mt-4">
                      Ensure your email for registration
                    </h4>
                    <v-form ref="formRegister" v-model="registerValid">
                      <v-text-field
                        label="ชื่อ"
                        name="Name"
                        prepend-icon="mdi-account"
                        type="text"
                        color="green"
                        :rules="[required]"
                        v-model="registerModel.firstName"
                      />
                      <v-text-field
                        label="นามสกุล"
                        name="Name"
                        prepend-icon="mdi-account"
                        type="text"
                        color="green"
                        :rules="[required]"
                        v-model="registerModel.lastName"
                      />
                      <v-text-field
                        label="Email"
                        name="Email"
                        prepend-icon="mdi-email"
                        type="text"
                        color="green"
                        :rules="[required, email]"
                        v-model="registerModel.email"
                      />

                      <v-text-field
                        id="password"
                        label="รหัสผ่าน"
                        name="password"
                        prepend-icon="mdi-lock"
                        type="password"
                        color="green"
                        :rules="[required]"
                        v-model="registerModel.password"
                      />
                    </v-form>
                  </v-card-text>
                  <div class="text-center mt-n5 pa-4">
                    <v-btn @click="singup" rounded color="green" dark
                      >SIGN UP</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color">
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    step: 1,
    loginValid: false,
    registerValid: false,
    showPassword: false,
    required: (value) => !!value || "Required.",
    email: (value) => {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Invalid e-mail.";
    },
    snackbar: {
      show: false,
      text: "",
      color: "success",
    },
    loginModel: {
      email: "",
      password: "",
    },
    registerModel: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
  }),
  props: {
    source: String,
  },
  watch: {
    step(index) {
      if (index === 1) {
        this.$refs.formLogin.reset();
      }
      if (index === 2) {
        if (this.$refs.formRegister) {
          this.$refs.formRegister.reset();
        }
      }
    },
  },
  methods: {
    async singup() {
      try {
        this.$refs.formRegister.validate();
        if (this.registerValid) {
          const user = {
            firstName: this.registerModel.firstName,
            lastName: this.registerModel.lastName,
            email: this.registerModel.email,
            password: this.registerModel.password,
          };
          console.log("login", user);
          const result = await this.$auth.singup(user);
          console.log(result);
          if (result.result) {
            this.snackbar.text = "Success";
            this.snackbar.color = "success";
            this.snackbar.show = true;
            setTimeout(() => {
              this.registerModel.firstName = "";
              this.registerModel.lastName = "";
              this.registerModel.email = "";
              this.registerModel.password = "";
              this.$refs.formRegister.reset();
              this.step--;
            }, 500);
          } else {
            this.$refs.formRegister.reset();
            this.registerModel.firstName = "";
            this.registerModel.lastName = "";
            this.registerModel.email = "";
            this.registerModel.password = "";
            this.snackbar.text = "Error";
            this.snackbar.color = "error";
            this.snackbar.show = true;
          }
        }
      } catch (error) {
        console.log("LOGIN: ", error.response);

        this.$refs.formRegister.reset();
        this.registerModel.firstName = "";
        this.registerModel.lastName = "";
        this.registerModel.email = "";
        this.registerModel.password = "";
        this.snackbar.text = error.response
          ? error.response.data.message
          : "มีบางอย่างผิดปกติกรุณาติดต่อผู้ดูแลระบบ";
        this.snackbar.color = "error";
        this.snackbar.show = true;
      }
    },
    async login() {
      try {
        this.$refs.formLogin.validate();
        if (this.loginValid) {
          console.log("login");
          const result = await this.$auth.login(
            this.loginModel.email,
            this.loginModel.password,
            this.$route.query.redirect
          );
          console.log("LOGIN: ", result);
          if (result) {
            this.snackbar.text = "Success";
            this.snackbar.color = "success";
            this.snackbar.show = true;
          } else {
            this.loginModel.email = "";
            this.loginModel.password = "";
            this.$refs.formLogin.reset();
            this.snackbar.text = "Error";
            this.snackbar.color = "error";
            this.snackbar.show = true;
          }
        } else {
          this.snackbar.text = "Error valid form";
          this.snackbar.color = "error";
          this.snackbar.show = true;
        }
      } catch (error) {
        console.log("LOGIN: ", error);
        this.loginModel.email = "";
        this.loginModel.password = "";
        this.$refs.formLogin.reset();
        this.snackbar.text = error.response
          ? error.response.data.message
          : "เข้าใช้งานไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้งานหรือรหัสผ่าน";
        this.snackbar.color = "error";
        this.snackbar.show = true;
      }
    },
  },
};
</script>
